<template>
    <section>
        <v-row no-gutters style="height:">
            <v-col cols="12">
                <v-btn v-for="(type, index) in types"
                    :class="[typeColor(type), 'type-button']"
                    :large="$vuetify.breakpoint.smAndUp && selectedTypesIndexes.indexOf(index) > -1"
                    depressed tile dark :small="$vuetify.breakpoint.xs && !(selectedTypesIndexes.indexOf(index) > -1)"
                    @click="selectedTypesIndexes = [index]"
                    :key="type">
                    {{type}}
                </v-btn>
            </v-col>
        </v-row>
        <v-row no-gutters class="fill-height">
            <v-col cols="12" :md="selectedOpen ? 8 : 12">
                <v-sheet class="pr-md-5" color="transparent">
                    <v-toolbar flat dark :class="typeColor(selectedTypes[0])">
                        <div class="d-flex justify-center align-center" style="width:100%">
                            <v-btn  fab text @click="prev">
                                <v-icon>mdi-chevron-left</v-icon>
                            </v-btn>
                            <v-toolbar-title style="cursor: pointer">{{ selectedMonth.title }}</v-toolbar-title>
                            <v-btn fab text @click="next">
                                <v-icon>mdi-chevron-right</v-icon>
                            </v-btn>
                        </div>
                    </v-toolbar>
                </v-sheet>
                <v-sheet height="600" class="pr-md-5 pb-5" color="transparent">
                    <v-calendar
                    ref="calendar"
                    v-model="focus"
                    :show-month-on-first="false"
                    event-overlap-mode="stack"
                    event-name="fullname"
                    :event-color="courseColor"
                    weekdays="1,2,3,4,5,6,0"
                    locale="nb-NO"
                    color="secondary"
                    :start="start"
                    :events="filteredCourses"
                    type="month"
                    @click:event="showEvent"
                    @mouseenter:event="previewEvent"
                    @mouseleave:event="closePreviewEvent"
                    @change="updateRange">
                    </v-calendar>
                    <v-menu v-if="!mobileAndTabletcheck" v-model="previewOpen" :close-on-content-click="false" :activator="selectedElement" absolute :position-x="mouse.x" :position-y="mouse.y">
                        <v-card color="grey lighten-4" width="300px" raised>
                            <v-card-title style="word-break: break-word" v-html="selectedCourse.fullname"></v-card-title>
                            <v-card-subtitle style="font-weight: bold">{{selectedCourse.startPlain}} - {{selectedCourse.endPlain}}</v-card-subtitle>
                            <v-card-text>
                                <p>{{selectedCourse.address}}</p>
                                <p>{{selectedCourse.price && selectedCourse.price.match(/\d+/g)[0]}} NOK/Pers. </p>
                            </v-card-text>
                        </v-card>
                    </v-menu>
                </v-sheet>
            </v-col>
            <v-col  cols="12" :md="selectedOpen ? 4 : 0">
                <v-card v-if="selectedOpen" id="registerCard" flat tile color="transparent">
                    <v-toolbar flat height="100" :class="typeColor(selectedTypes[0])" dark>
                        <v-toolbar-title v-html="toolbarHeader"></v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-toolbar-items>
                            <v-btn icon @click="selectedOpen = false">
                                <v-icon dark>mdi-close</v-icon>
                            </v-btn>
                        </v-toolbar-items>
                    </v-toolbar>
                    <v-card-text id="registerForm">
                        <v-spacer></v-spacer>
                        <Form :selectedCourse="selectedCourse" />
                    </v-card-text>
                </v-card>
                <v-alert id="registeredSuccess" v-model="registeredSuccess" dismissible type="success">
                    Du har blitt registrert.
                </v-alert>
            </v-col>
        </v-row>

    </section>
</template>

<script>
import Api from '../utils/api.js'
import eventHelper from '@/mixins/event.js'
import Form from './Form.vue'
import VueScrollTo from 'vue-scrollto'

export default {
    components: {
        Form
    },
    computed: {
        types(){
            return ["Lift","Truck", "Teleskoptruck"];
        },
        selectedTypes(){
            return this.types.filter((el, index) => { return this.selectedTypesIndexes.indexOf(index) > -1 });
        },
        filteredCourses(){
            return this.courses.filter((course) => 
                this.selectedTypesIndexes.length == 0 
                || this.selectedTypes.some((el) => `Kurs - ${el}` == course.type))
        },
        start() {
            return `${this.selectedMonth.year}-${this.selectedMonth.month}-01`
        },
        toolbarHeader(){
            return `<strong>${this.selectedCourse.fullname}</strong><br>
            <small>${this.selectedCourse.startPlain} - ${this.selectedCourse.endPlain}</small><br> 
            <small>${this.selectedCourse.address}</small>`
        },
        mobileAndTabletcheck() {
            var check = false;
            //eslint-disable-next-line no-useless-escape
            (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
            return check;
        }
    },
    data: function(){
        return {
            selectedMonth: {
                month: new Date().getMonth() + 1,
                year: new Date().getFullYear(),
                title: ''
            },
            mouse: {
                x: null,
                y: null
            },
            selectedTypesIndexes: [this.defaultType],
            selectedCourse: {type: '', name:''},
            selectedElement: null,
            selectedOpen: false,
            previewOpen: false,
            courses: [],
            focus: '',
            registeredSuccess: false
        }
    },
    created: async function(){
        await Api.getCourses().then((result) => {
            this.courses = result.data.map((course) => {
                return { 
                    id: course.dynamics_id,
                    address: course.address,
                    price: course.price,
                    fullname: course.name == null ? '' : course.name,
                    type: course.type,
                    startPlain: course.course_start,
                    endPlain: course.course_end,
                    start: this.formatDate(course.course_start),
                    end: this.formatDate(course.course_end)
                }
            })
        });
    },
    mixins: [eventHelper],
    props: {
        defaultType: Number,
    },
    methods: {
        updateRange ({ start }) {
            const startMonth = this.monthFormatter(start)
            this.selectedMonth = { month: start.month, year: start.year, title: `${startMonth} ${start.year}`}
        },
        monthFormatter(month) {
            return this.$refs.calendar.getFormatter({
                timeZone: 'UTC', month: 'long',
            })(month)
        },
        prev() {
            this.$refs.calendar.prev()
        },
        next() {
            this.$refs.calendar.next()
        },
        formatDate(date){
            var split = date.split(' ')
            var day = split[0].split('.')
            var pDate = new Date(day[2], day[1]-1, day[0])
            var hours = split[1].replace('.', ':')
            return `${pDate.getFullYear()}-${pDate.getMonth()+1}-${pDate.getDate()} ${hours}`
        },
        showEvent ({ nativeEvent, event }) {
            const open = () => {
                this.registeredSuccess = false
                this.selectedCourse = event
                this.selectedElement = nativeEvent.target
                setTimeout(() => {
                    this.selectedOpen = true;
                    this.previewOpen = false; 
                     setTimeout(() => { 
                        if (this.mobileAndTabletcheck){
                            VueScrollTo.scrollTo("#registerCard", 800);
                        }
                    }, 10);
                }, 10);
            }
            open()
        },
        previewEvent ({ nativeEvent, event }) {
            this.selectedCourse = event
            this.selectedElement = nativeEvent.target
            this.mouse.x = this.selectedElement.getBoundingClientRect().left
            this.mouse.y = this.selectedElement.getBoundingClientRect().bottom 
            setTimeout(() => this.previewOpen = true, 5)
            nativeEvent.stopPropagation()
        },
        closePreviewEvent ({ nativeEvent }) {
            this.previewOpen = false
            nativeEvent.stopPropagation()
        }
    },
    watch: {
        selectedTypesIndexes: function(){
            this.selectedOpen = false
        }
    }
}
</script>
<style>
.lys-turkis {
    background: #669999 !important;
}

.lys-turkis.lighten-4 {
    background: #b5d2d2;
}

.mork-turkis {
    background: #003333 !important;
}

.mork-turkis.lighten-4 {
    background: #5d7474;
}

#registerForm {
    box-sizing: border-box;
    padding: 16px 0;
}


#registerForm .v-input {
    height: 65px;
}

.type-button {
    vertical-align: bottom;
}

.v-event strong {
    display: none;
}
</style>